<template>
  <div class="documents">
    <div
      class="col-36"
      v-if="meta.attestationPiecesJustificatives?.$status === PropertyStatus.Required"
    >
      <WrapperCheckbox
        id="field_attestationPiecesJustificatives"
        v-model="attestationPiecesJustificativesModel"
        :alertLabel="meta.attestationPiecesJustificatives?.$messageErreurDirty!"
        label="L'employeur atteste disposer de l'ensemble des pièces justificatives nécessaires au dépôt de la demande de remboursement"
        :readonly
        class="wrapper-width-fit wrapper-without-margin-top"
      />
    </div>
    <UploadFichiers>
      <template
        #title
        v-if="enSimplificationAdministrative"
      >
        <BasicAlert
          alertType="danger"
          alertLabel="Vous êtes en « simplification administrative », vous n’avez donc pas l’obligation de nous transmettre les documents justificatifs sauf si votre dossier est lié à un cofinancement ou s’il s’agit d’un dossier AF PDC-50. "
          :hasBg="false"
        />
      </template>
    </UploadFichiers>
  </div>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { DEMANDE_STORE, UploadFichiers } from '@/features/interface/demande/shared/components'
  import { storeToRefs } from 'pinia'
  import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_DR'>()
  const { setupFieldWithKey } = store

  const { meta, readonly, enSimplificationAdministrative } = storeToRefs(store)

  const attestationPiecesJustificativesModel = setupFieldWithKey<boolean>('attestationPiecesJustificatives')
</script>

<style scoped lang="less">
  .documents {
    display: flex;
    flex-direction: column;
    gap: @spacing-25;

    &__section {
      display: flex;
      flex-direction: column;
      gap: @spacing-15;

      &__button {
        width: 500px;
      }
    }
  }
</style>
